export default "__VITE_ASSET__Bnso0$eh__"